import FileService from '../../services/file-service';
import FormatService from '../../services/format-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../constants/system/file-extensions';
import { CONTACT_TYPE_COMPANY, CONTACT_TYPE_PERSON } from '../../constants/entity/contact-types';

const ContactValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const contactPersonRequiredFields: string[] = [
    'firstName',
    'lastName',
    'type',
    'groupIds',
  ];

  const contactCompanyRequiredFields: string[] = [
    'name',
    'type',
    'groupIds',
  ];

  if (values.contactData) {
    if (!errors.contactData) {
      errors.contactData = {};
    }

    const requiredFields: string[] = values.contactData.type === CONTACT_TYPE_COMPANY ? contactCompanyRequiredFields
      : contactPersonRequiredFields;

    requiredFields.forEach((field: string): void => {
      if (!values.contactData[field] || !values.contactData[field].toString().trim()) {
        errors.contactData[field] = 'Required';
      }
    });

    if (values.contactData.type !== CONTACT_TYPE_PERSON && values.contactData.type !== CONTACT_TYPE_COMPANY) {
      errors.contactData.type = 'Incorrect contact type';
    }

    if (values.contactData.email && !FormatService.isValidEmail(values.contactData.email)) {
      errors.contactData.email = 'Invalid email address';
    }

    if (values.contactData.phone && !FormatService.isValidPhoneNumber(values.contactData.phone)) {
      errors.contactData.phone = 'Invalid phone number';
    }

    if (values.contactData.phoneWork && !FormatService.isValidPhoneNumber(values.contactData.phoneWork)) {
      errors.contactData.phoneWork = 'Invalid phone number';
    }

    if (!values.contactData.address && values.contactData.streetAddress) {
      errors.contactData.streetAddress = 'Incorrect address value';
    }

    if (values.contactData.photo
      && !FileService.checkFileExtension(values.contactData.photo, FILE_EXTENSION_LIST_IMAGE)) {
      errors.contactData.photo = 'Incorrect file type';
    }

    if (values.contactData.newContact && Object.keys(values.contactData.newContact).length) {
      const newContactData: ValidationEntityInput = {
        ...values.contactData.newContact,
      };

      if (!errors.contactData.newContact) {
        errors.contactData.newContact = {};
      }

      const newContactRequiredFields: string[] = newContactData.type === CONTACT_TYPE_PERSON
        ? contactPersonRequiredFields : contactCompanyRequiredFields;

      newContactRequiredFields.forEach((field: string): void => {
        if ((!newContactData[field] || !newContactData[field].toString().trim()) && newContactData[field] !== null) {
          errors.contactData.newContact[field] = 'Required';
        }
      });

      if (newContactData.type !== CONTACT_TYPE_PERSON && newContactData.type !== CONTACT_TYPE_COMPANY) {
        errors.contactData.newContact.type = 'Incorrect contact type';
      }

      if (newContactData.email && !FormatService.isValidEmail(newContactData.email)) {
        errors.contactData.newContact.email = 'Invalid email address';
      }

      if (newContactData.phone && !FormatService.isValidPhoneNumber(newContactData.phone)) {
        errors.contactData.newContact.phone = 'Invalid phone number';
      }

      if (newContactData.phoneWork && !FormatService.isValidPhoneNumber(newContactData.phoneWork)) {
        errors.contactData.newContact.phoneWork = 'Invalid phone number';
      }

      if (!newContactData.address && newContactData.streetAddress) {
        errors.contactData.newContact.streetAddress = 'Incorrect address value';
      }

      if (newContactData.photo && !FileService.checkFileExtension(newContactData.photo, FILE_EXTENSION_LIST_IMAGE)) {
        errors.contactData.newContact.photo = 'Incorrect file type';
      }

      if (errors.contactData.newContact && !Object.keys(errors.contactData.newContact).length) {
        delete errors.contactData.newContact;
      }
    }
  }

  if (errors.contactData && !Object.keys(errors.contactData).length) {
    delete errors.contactData;
  }

  return errors;
};

export default ContactValidator;
